import CustomInput from "../../eventcreation/components/CustomInput";
import { makeStyles } from "@mui/styles";
// import { customTheme as theme } from "../../../theme/customTheme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FocusTrap from "@mui/base/FocusTrap";
import useValidator from "../../../hooks/useValidator";
import { userResendLink } from "../../../services/api";
import { afterValidate, setInput } from "../../../utils/commonServices";
import { updateState } from "../../../redux/commonSlice";
// import ForgotPasswordPopup from "./ForgotPasswordPopup";
import useAuthRequest from "../../../hooks/useAuthRequest";
// import EmailVerificationPopup from "./EmailVerificationPopup";
// import CustomSnackbar from "../../components/CustomSnackbar";
// import CustomSnackbarDrawer from "../../components/CustomSnackbarDrawer";
import movieIcon from '../../../assets/movieIcon.svg';
import { Box, Grid, Paper, Typography } from '@mui/material';
import UnauthLayout from '../components/UnauthLayout'
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import "@fontsource/rubik";
import { PRODUCT_ID } from "../../../constants/constants";
import useCustomTheme from "../../../theme/useCustomTheme";

const useStyles = makeStyles((theme) => ({
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    minHeight: "100%",
  },
}));

const ResendLink = () => {

    const location = useLocation()
    const navigate = useNavigate();
    // const {pageData, title, icon, btnText, message, signIn} = location.state
    
     const classes = useStyles();
     const [theme ] = useCustomTheme()
     const [resendLink, status] = useAuthRequest("resend-link")
/////test data ///
const pageData = {
  email:'',
  name:''
}

const title = 'Your registration is under process.'
const message = ' You will receive a verification email once your registration is processed. If you did not receive a mail within 24 hours please contact lucihub sales'




      // useEffect(()=> {
      //     if(status == "verified") {
      //         navigate("/", {replace: true})
      //     }
      // }, [status])

        
  return (
    <UnauthLayout both>
        <Box className={classes.centerBox} flexDirection='column'>

<Box px={4} pb={3}>
     <Box className={classes.centerBox} mb={7} >
      {/* <CheckRoundedIcon style={{fontSize:'4rem', color:theme.palette.primary.main}}/> */}
       {/* <img src={icon ? icon : movieIcon} className={classes.movieIcon} /> */}
     </Box>

     <Box className={classes.centerBox} flexDirection='column' mb={3}>
        <Typography 
                color="primary"
                style={{
                  fontWeight: 600,
                  color:'#08231B',
                  textAlign: 'center',
                  textTransform: 'none'
                }}
                sx={{fontSize:{xs:'30px',sm:'35px',md:'40px',lg:'50px',xl:'80px'},mb:1, fontFamily:'Rubik'}}>{title? title :''}</Typography>

        <Typography 
                color="primary"
                style={{
                  fontWeight: 300,
                  color:'#08231B',
                  textAlign: 'center',
                  textTransform: 'none'
                }}
                sx={{fontSize:{xs:'10px',sm:'13px',md:'15px',lg:'17px',xl:'30px'}, fontFamily:'Rubik'}} >{message? message :''}</Typography>

     </Box>
     <Box sx={{width:'100%', textAlign:'center'}}>
         {/* <CustomButton  
         disabled={status == "loading"}
         // btnText="Resend Verification Link"
         btnText={btnText? btnText :'resend link'}
         variant="contained"
         color="primary"
         size="medium"
         onClick={resendLinkClickHandler}
         style={{
             fontSize: 18,
             borderRadius: 50,
              maxWidth: 370,
              minWidth: 90,
              marginTop: 30
         }}/> */}
         {/* <Typography color="primary"
                style={{
                  fontWeight: 300,
                  color:'#08231B',
                  textAlign: 'center',
                  textTransform: 'none'
                }}
                sx={{fontSize:{xs:'10px',sm:'13px',md:'15px',lg:'17px',xl:'30px'}, fontFamily:'Rubik'}}> If you haven't received our email, please contact Lucihub Sales. 
         </Typography> */}
     </Box>
 </Box>

</Box>
    </UnauthLayout>
  )
}

export default ResendLink
